import { render } from "./CancelCloseOrder.vue?vue&type=template&id=08d8d2ff&scoped=true"
import script from "./CancelCloseOrder.vue?vue&type=script&lang=js"
export * from "./CancelCloseOrder.vue?vue&type=script&lang=js"

import "./CancelCloseOrder.vue?vue&type=style&index=0&id=08d8d2ff&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d8d2ff"]])

export default __exports__